import React, { useState } from 'react';
import EpisodeOfCareRecord from './EpisodeOfCareRecord';
import { ProcedureDetails } from '../dialogs/EpisodeOfCareDetails';

const ProcedureRecord = ({ procedure, ...props }) => {
  const [visible, setVisible] = useState(false);
  const handleProcedureClick = () => {
    setVisible(true);
  };
  const handleDialogClose = () => setVisible(false);

  return (
    <>
      <ProcedureDetails
        procedure={procedure}
        visible={visible}
        onCancel={handleDialogClose}
      />
      <EpisodeOfCareRecord
        record={procedure}
        {...props}
        onClick={handleProcedureClick}
      />
    </>
  );
};

export default ProcedureRecord;
